const { Typography, Box, Divider } = require("@mui/material");
const { default: getStatusColor } = require("./getStatusColor");


const StatusProgress = ({ deployments, deploymentLogs, userId }) => {
    const latest = deployments[userId];
    const logs = deploymentLogs[userId] || [];

    return (
        <Box sx={{ mb: 2 }}>
            {latest && (
                <>
                    <Typography variant="h5" gutterBottom>
                        <Box component="span" sx={{ fontWeight: 700 }}>Progress:</Box> {latest.progress}%
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                        <Box component="span" sx={{ fontWeight: 700 }}>Status:</Box>{' '}
                        <Box component="span" sx={{ fontWeight: 700, color: getStatusColor(latest.status) }}>
                            {latest.status}
                        </Box>
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                        <Box component="span" sx={{ fontWeight: 700 }}>Step:</Box> {latest.statusText}
                    </Typography>
                    {latest.error && (
                        <Typography variant="body1" color="error">
                            <strong>Error:</strong> {latest.error}
                        </Typography>
                    )}
                    <Divider sx={{ my: 2 }} />
                </>
            )}

            {/* Full log history */}
            <Typography variant="h6" gutterBottom>
                <Box component="span" sx={{ fontWeight: 700 }}>Log History:</Box>
            </Typography>
            <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
                {logs.map((log, index) => (
                    <Box key={index} sx={{ mb: 1 }}>
                        <Typography variant="body2"><strong>Step:</strong> {log.statusText}</Typography>
                        <Typography variant="body2"><strong>Status:</strong> {log.status}</Typography>
                        <Typography variant="body2"><strong>Progress:</strong> {log.progress}%</Typography>
                        {log.error && (
                            <Typography variant="body2" color="error"><strong>Error:</strong> {log.error}</Typography>
                        )}
                        <Divider sx={{ my: 1 }} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};


export default StatusProgress;